module.exports = __webpack_public_path__ + "img/intro9.f0dd3bb6.jpg";